module.exports = __webpack_public_path__ + "img/2-4-1.29d4607e.png";